import { render, staticRenderFns } from "./SelfLinkPrompt.vue?vue&type=template&id=7e8465de&scoped=true"
import script from "./SelfLinkPrompt.vue?vue&type=script&lang=js"
export * from "./SelfLinkPrompt.vue?vue&type=script&lang=js"
import style0 from "./SelfLinkPrompt.vue?vue&type=style&index=0&id=7e8465de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8465de",
  null
  
)

export default component.exports